import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment-timezone";
import { Link } from "react-router-dom";

class SignupsTableContainer extends Component {
  state = {
    signups: []
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("signups")
      .orderBy("timestamp", "desc")
      .limit(100)
      .get()
      .then(querySnapshot => {
        let signups = [];
        querySnapshot.forEach(doc => {
          let signup = doc.data();
          signup["id"] = doc.id;
          signup["created"] = moment(signup.timestamp.toDate()).unix();
          signups.push(signup);
        });
        this.setState({ signups: signups });
      });
  };

  render() {
    const signupStatus = {
      0: "Not completed",
      1: "Completed",
      2: "Canceled/Expired/Failed",
      3: "Completed"
    };
    return (
      <div style={{ width: "100%", marginTop: 10 }}>
        <div style={{ margin: "0 15px" }}>Laatste 100 inschrijvingen:</div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>TournamentId</TableCell>
              <TableCell>Payment method</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Num teams</TableCell>
              <TableCell>Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.signups.map(signup => (
              <TableRow key={signup.id}>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  {moment.unix(signup.created).format("D MMMM YYYY HH:mm")}
                </TableCell>
                <TableCell>
                  <Link
                    to={"/tournament/" + signup.tournamentId}
                    target="_blank"
                  >
                    {signup.tournamentId}
                  </Link>
                </TableCell>
                <TableCell>
                  {signup.paymentMethod === "0" ? "Mollie connect" : ""}
                </TableCell>
                <TableCell>{signupStatus[signup.status]}</TableCell>
                <TableCell>{(signup.teams || []).length}</TableCell>
                <TableCell>{signup.email}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default SignupsTableContainer;
